import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle } = FiIcons;

const GarmentRow = ({ garment }) => {
  const status = garment.metadata?.GarmentStatus || '';
  const isUnlinked = status.toLowerCase().includes('unlinked');
  const rfid = garment.metadata?.RFID || garment.rfid;
  
  const displayBarcode = garment.barcode?.startsWith('MISSING-') 
    ? 'Sin código' 
    : (garment.barcode || '---');

  return (
    <div className={`rounded-lg p-3 border relative transition-colors ${
      isUnlinked ? 'bg-red-50 border-red-200 shadow-sm' : 'bg-white border-gray-100'
    }`}>
      <div className="flex justify-between items-start mb-2">
        <span className={`text-sm font-bold ${isUnlinked ? 'text-red-800' : 'text-gray-700'}`}>
          {garment.garment || 'Prenda desconocida'}
        </span>
        {garment.size && (
          <span className="w-6 h-6 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center shadow-sm shrink-0">
            {garment.size}
          </span>
        )}
      </div>

      <div className="text-xs space-y-1.5">
        <div className="flex items-center gap-2">
          <span className="text-gray-400 font-medium w-16">Barcode:</span>
          <span className="font-mono text-gray-600 bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100 select-all">
            {displayBarcode}
          </span>
        </div>
        
        <div className="flex items-center gap-2">
          <span className={`font-medium w-16 ${isUnlinked ? 'text-red-400' : 'text-gray-400'}`}>
            RFID:
          </span>
          {rfid ? (
            <span className="font-mono text-gray-600 bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100 select-all">
              {rfid}
            </span>
          ) : (
            <span className="text-gray-400 italic">N/A</span>
          )}
        </div>
      </div>
      
      {isUnlinked && (
        <div className="mt-2 text-[10px] text-red-600 font-bold uppercase tracking-wider text-right flex justify-end items-center gap-1">
          <SafeIcon icon={FiAlertCircle} className="text-xs" />
          Prenda desvinculada &gt; Retirar
        </div>
      )}
    </div>
  );
};

export default GarmentRow;